import { parse } from 'yaml';
import { isFilesystem } from './isFilesystem.js';

/**
 * Normalize the OpenAPI document (YAML, JSON, object) to a JavaScript object.
 *
 * Doesn’t modify the object if it’s a `Filesystem` (multiple files) already.
 */
function normalize(specification) {
    if (specification === null) {
        return {};
    }
    if (typeof specification === 'string') {
        if (specification.trim() === '') {
            return {};
        }
        try {
            return JSON.parse(specification);
        }
        catch (_error) {
            return parse(specification, {
                maxAliasCount: 10000,
            });
        }
    }
    if (isFilesystem(specification)) {
        return specification;
    }
    return specification;
}

export { normalize };
